import _ from 'lodash';

const structureTypeDetail=(dwellingVM,homeownersVM,policyTypeCode,viewModelService)=>{
    let hoQuestionSet;
    

    // const structureTypeList =view
    switch (policyTypeCode) {
        case 'TWRD':
            hoQuestionSet = _.first(_.filter(homeownersVM.preQualQuestionSets.value, (qs) => qs.code === 'TWIA_Pre_Qual_Property_DWPolicy'));

            if (hoQuestionSet && hoQuestionSet.answers) {
                const termTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('StructureType_TWIA');

                if (termTypeList.hasCode(hoQuestionSet.answers.PreQual_Prop_StructureType)) {
                    const termTypeCode = termTypeList.getCode(hoQuestionSet.answers.PreQual_Prop_StructureType);

                    _.set(dwellingVM, 'structureType_TWIA.value', termTypeCode.code);
                }
            }

            break;
        case 'TWRM':
            // US11936 defaulting structure type in not present
            if (dwellingVM.value.structureType_TWIA !== 'MHWithPPOnly'
                && dwellingVM.value.structureType_TWIA !== 'MHWithPpOpt') {
                _.set(dwellingVM, 'structureType_TWIA.value', 'MHWithPPOnly');
            }

            // US26300
            _.set(dwellingVM, 'dwellingUsage.value', undefined );
            break;
        case 'TWRP':
            hoQuestionSet = _.first(_.filter(homeownersVM.preQualQuestionSets.value, (qs) => qs.code === 'TWIA_Pre_Qual_Property_TPPolicy'));

            if (hoQuestionSet && hoQuestionSet.answers) {
                _.set(dwellingVM, 'structureType_TWIA.value', hoQuestionSet.answers.PreQual_Prop_StructureType_TP)
            }

            break;
            case 'TWRC':
                    _.set(dwellingVM, 'structureType_TWIA.value', 'Condo');
                    
                break;
        default:
    }

}



export default {
    'structureTypeDetail': structureTypeDetail
}